/**
 * 是否选项
 */
export const yesOrNo_options = [
    {
        value: true,
        display: "是"
    },
    {
        value: false,
        display: "否"
    }
]

export const shortcuts_options1 = [
    {
        text: '今天',
        onClick(picker) {
            const date = new Date(new Date(new Date().toLocaleDateString()).getTime());
            picker.$emit('pick', date);
        }
    },
    {
        text: '昨天',
        onClick(picker) {
            const date = new Date(new Date(new Date().toLocaleDateString()).getTime());
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
        }
    },
    {
        text: '一周前',
        onClick(picker) {
            const date = new Date(new Date(new Date().toLocaleDateString()).getTime());
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
        }
    }
]

export const shortcuts_options2 = [
    {
        text: '今天',
        onClick(picker) {
            const date = new Date(new Date(new Date().toLocaleDateString()).getTime());
            picker.$emit('pick', date);
        }
    },
    {
        text: '明天',
        onClick(picker) {
            const date = new Date(new Date(new Date().toLocaleDateString()).getTime());
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
        }
    },
    {
        text: '一周后',
        onClick(picker) {
            const date = new Date(new Date(new Date().toLocaleDateString()).getTime());
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
        }
    }
]

export const shortcuts_options3 = [
    {
        text: "今天",
        onClick(picker) {
            picker.$emit("pick", new Date());
        }
    },
    {
        text: "一周前",
        onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", date);
        }
    },
    {
        text: "一月前",
        onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", date);
        }
    },
    {
        text: "一年前",
        onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit("pick", date);
        }
    },
]
export const shortcuts_options4 = [
    {
        text: '明天',
        onClick(picker) {
            const date = new Date(new Date(new Date().toLocaleDateString()).getTime());
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
        }
    },
    {
        text: "一周后",
        onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit("pick", date);
        }
    },
    {
        text: "一月后",
        onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
            picker.$emit("pick", date);
        }
    },
    {
        text: "一年后",
        onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 365);
            picker.$emit("pick", date);
        }
    },
  
  
  
]